import { TFunction } from 'i18next'
import { OnboardingStep } from 'types/onboardingTypes'
import { title } from './Consts'

export function getPerfectWeight(t: TFunction): OnboardingStep {
  const perfectWeight = 'perfect_weight'

  return {
    id: perfectWeight,
    type: 'weight',
    wordings: {
      title: t(`${perfectWeight}.${title}`),
      placeholder: ''
    }
  }
}
